import { styled } from "@mui/material";

const MenuTooltip = styled("div")`
  white-space: pre-line;
  font-size: 1.5em;
`;

export { MenuTooltip };
